import dayjs, { type Dayjs } from 'dayjs';

/**
 * Suggested "First submission deadline" when adding a tax return:
 * period end + 1 calendar month + 15 days, then normalized to the 15th of that month.
 *
 * Example: period 01/10/2025–31/12/2025 → end 31/12/2025 → +1M +15d = 15/02/2026 → 15 Feb.
 */
export function suggestFirstSubmissionDeadlineAfterPeriodEnd(
  periodEndYmd: string
): Dayjs {
  const end = dayjs(periodEndYmd);
  const anchor = end.add(1, 'month').add(15, 'day');
  return anchor.date(15);
}
